import React, { useMemo } from "react";

import Design from "../../../../../../features/announcements/components/designs/Design";
import { useOpticsStore } from "../../../../../../stores/use-optics-store";
import {
  AnnouncementsTemplatesContainer,
  DesignContainer,
  OverviewDesignContainer,
  OverviewAnnouncementsTemplatesContainer,
  OverviewAnnouncementsTemplateContainer,
  OverviewAnnouncementsMultipleTemplateContainer,
} from "./styles";
import { getAnnouncementsTemplates } from "./announcements-templates";
import { useAnnouncementsStore } from "../../../../../../stores/use-announcements-store";
import { MACRO_KEY } from "../../../../../defaults";

export const OverviewTemplates = () => {
  const { handleClickOnTemplate } = useAnnouncementsStore((state) => ({
    handleClickOnTemplate: state.handleClickOnTemplate,
  }));
  const { setDrawers, styleguideSetup, setMacro } = useOpticsStore((state) => ({
    setDrawers: state.setDrawers,
    styleguideSetup: state.styleguideSetup,
    setMacro: state.setMacro,
  }));

  const templates = useMemo(
    () =>
      getAnnouncementsTemplates({
        ...(styleguideSetup || {}),
        isInOverview: true,
      }),
    [styleguideSetup]
  );

  const splitTemplates = [
    templates.slice(0, 1),
    templates.slice(1, 3),
    templates.slice(3),
  ];

  return (
    <OverviewAnnouncementsTemplatesContainer>
      <OverviewAnnouncementsTemplateContainer>
        {splitTemplates[0].map((template) => (
          <OverviewDesignContainer
            key={template.announcement.id}
            hasHover
            borderRadius={styleguideSetup.cornerRadius}
            onClick={() => {
              setMacro({ key: MACRO_KEY.ANNOUNCEMENTS });
              handleClickOnTemplate(template);
              setDrawers({ templates: false, settings: true });
            }}
          >
            <Design
              config={{ ...template.config, view: "card" }}
              data={template.announcement}
              viewMode="edit"
            />
          </OverviewDesignContainer>
        ))}
      </OverviewAnnouncementsTemplateContainer>
      <OverviewAnnouncementsMultipleTemplateContainer>
        {splitTemplates[1].map((template) => (
          <OverviewDesignContainer
            key={template.announcement.id}
            hasHover
            borderRadius={styleguideSetup.cornerRadius}
            onClick={() => {
              setMacro({ key: MACRO_KEY.ANNOUNCEMENTS });
              handleClickOnTemplate(template);
              setDrawers({ templates: false, settings: true });
            }}
          >
            <Design
              config={{ ...template.config, view: "card" }}
              data={template.announcement}
              viewMode="edit"
            />
          </OverviewDesignContainer>
        ))}
      </OverviewAnnouncementsMultipleTemplateContainer>
      <OverviewAnnouncementsTemplateContainer>
        {splitTemplates[2].map((template) => (
          <OverviewDesignContainer
            key={template.announcement.id}
            hasHover
            borderRadius={styleguideSetup.cornerRadius}
            onClick={() => {
              setMacro({ key: MACRO_KEY.ANNOUNCEMENTS });
              handleClickOnTemplate(template);
              setDrawers({ templates: false, settings: true });
            }}
          >
            <Design
              config={{ ...template.config, view: "card" }}
              data={template.announcement}
              viewMode="edit"
            />
          </OverviewDesignContainer>
        ))}
      </OverviewAnnouncementsTemplateContainer>
    </OverviewAnnouncementsTemplatesContainer>
  );
};

const AnnouncementsTemplates = () => {
  const { handleClickOnTemplate } = useAnnouncementsStore((state) => ({
    handleClickOnTemplate: state.handleClickOnTemplate,
  }));
  const { setDrawers, styleguideSetup } = useOpticsStore((state) => ({
    setDrawers: state.setDrawers,
    styleguideSetup: state.styleguideSetup,
  }));

  const templates = useMemo(
    () => getAnnouncementsTemplates(styleguideSetup),
    [styleguideSetup]
  );

  return (
    <AnnouncementsTemplatesContainer>
      {templates.map((template) => (
        <DesignContainer
          key={template.announcement.id}
          hasHover
          onClick={() => {
            handleClickOnTemplate(template);
            setDrawers({ templates: false, settings: true });
          }}
        >
          <Design
            isTemplate
            config={{ ...template.config, view: "card" }}
            data={template.announcement}
            viewMode="edit"
          />
        </DesignContainer>
      ))}
    </AnnouncementsTemplatesContainer>
  );
};

export default AnnouncementsTemplates;
